import React from "react";

function Info(){
    return(
        <div className = "liam_contact_info">
            <a id="linked_in" href="https://www.linkedin.com/in/liam-mazure">LinkedIn: liam-mazure</a>
            <a id="git_hub" href="https://github.com/Liam-Mazure">GitHub: Liam-Mazure</a>
            <p id="email_addr">Email: liammazure2001@gmail.com</p>
        </div>
    )
}

export default Info;